import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RootState } from "../setup/redux/Store";
import { ThemeProvider } from "../_start/layout/core";
import { MasterLayout } from "../_start/layout/MasterLayout";
import { Logout } from "./modules/auth/Logout";
import { PrivateRoutes } from "./routing/PrivateRoutes";
import { PublicRoutes } from "./routing/PublicRoutes";
import { ErrorsPage } from "./modules/errors/ErrorsPage";
import { SurveyPage } from "./pages/public/SurveyPage";
import { PublicReportPage } from "./pages/public/PublicReportPage";
import { AcceptInvitePage } from "./pages/team/AcceptInvitePage";

type Props = {
  basename: string;
};

const App: React.FC<Props> = ({ basename }) => {
  const isAuthorized = useSelector((state: RootState) => state.auth.user);

  return (
    <BrowserRouter basename={basename}>
      <ThemeProvider>
        <Routes>
          {/* Public routes that work regardless of auth status */}
          <Route path="/s/:surveyId" element={<SurveyPage />} />
          <Route path="/report/:slug" element={<PublicReportPage />} />
          <Route path="/team/accept" element={<AcceptInvitePage />} />
          <Route path="/error/*" element={<ErrorsPage />} />
          <Route path="/logout" element={<Logout />} />
          {!isAuthorized ? (
            <Route path="/*" element={<PublicRoutes />} />
          ) : (
            <Route
              path="/*"
              element={
                <MasterLayout>
                  <PrivateRoutes />
                </MasterLayout>
              }
            />
          )}
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export { App };
